/**
 *
 * Ask
 *
 */

import { mapState } from 'vuex';

import { QaTagsMixin } from '@/mixins/QA/Tags';
import { QaTitleMixin } from '@/mixins/QA/Title';

import QaLimit from '@/components/QA/Limit.vue';

// QaMixin
export const QaAskMixin = {
  name: 'QaAskMixin',

  mixins: [QaTagsMixin, QaTitleMixin],

  components: {
    'qa-limit': QaLimit,
  },

  data: () => {
    return {};
  },

  computed: {
    ...mapState('Mixins/QA', {
      ms_res_doQuestionNew: 'res_doQuestionNew',
    }),

    ///
    c_isSubmitDisabled() {
      return this._c_isSubmitDisabled || !this.c_isSelectedTagsReady || !this.c_isQaTitleReady;
    },
  },

  methods: {
    ///
    async afterPostQA() {
      if (200 !== this.ms_res_doQuestionNew.status) {
        await this.swalPostQAFailure(this.ms_res_doQuestionNew.message);
      } else if (this.ms_res_doQuestionNew.data.hasQuestioned) {
        await this.swalPostQAFailure('您刚刚提交了问题，请3分钟后再提交问题');
      } else if (!this.ms_res_doQuestionNew.data.postSuccess) {
        await this.swalPostQAFailure(this.ms_res_doQuestionNew.message);
      } else {
        await this.afterPostQaSuccess();
      }
    },

    ///
    doClearQA() {
      this.clearSelectedTag();
      this.clearQaTitle();
    },
  },
};

export default QaAskMixin;
